import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-[#111827] py-12" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-52">
        <div className="mb-6" data-id="element-53">
          <Logo showText={true} size="md" variant="light" data-id="element-54" />
        </div>
        <p className="text-gray-400 text-sm text-center" data-id="element-55">
          © 2026 Obra Digital. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}